<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default { name: 'App' }
</script>

<style>
/* ==================== 青橙枝恋 · 全局主题 ==================== */
/* 与小程序端（青橙枝恋）视觉体系统一：主题粉 + 暖橙辅助色 */
:root {
  --primary: #ff608d;
  --primary-dark: #e84a78;
  --primary-light: #ff8fb0;
  --primary-bg: #fff0f5;
  --primary-50: #fff5f8;
  --accent: #f26631;
  --accent-dark: #d9571f;
  --accent-light: #ff8f66;
  --accent-bg: #fff2ec;
  --gradient: linear-gradient(135deg, #ff608d 0%, #f26631 100%);
  --gradient-soft: linear-gradient(135deg, #ff8fb0 0%, #ffa07a 100%);
  --success: #22a06b;
  --warning: #ef8d19;
  --danger: #f5455c;
  --text-primary: #333333;
  --text-secondary: #666666;
  --text-muted: #999999;
  --bg-page: #f5f5f7;
  --bg-card: #ffffff;
  --border: #f0f0f0;
  --border-strong: #e6e6e6;
  --shadow: 0 2px 8px rgba(255, 96, 141, 0.06), 0 1px 3px rgba(0, 0, 0, 0.03);
  --shadow-md: 0 6px 20px rgba(255, 96, 141, 0.12), 0 2px 6px rgba(0, 0, 0, 0.04);
  --radius: 12px;
  --radius-sm: 8px;
}

html, body, #app {
  height: 100%;
  margin: 0;
  padding: 0;
  font-family: 'PingFang SC', 'Microsoft YaHei', -apple-system, BlinkMacSystemFont, 'Helvetica Neue', sans-serif;
  -webkit-font-smoothing: antialiased;
  background: var(--bg-page);
  color: var(--text-primary);
}

* { box-sizing: border-box; }

::-webkit-scrollbar { width: 6px; height: 6px; }
::-webkit-scrollbar-track { background: transparent; }
::-webkit-scrollbar-thumb { background: #e0e0e0; border-radius: 3px; }
::-webkit-scrollbar-thumb:hover { background: var(--primary-light); }

/* ===== 对话框 ===== */
.edu-dialog .el-dialog__header {
  background: var(--gradient);
  padding: 16px 24px;
  border-radius: var(--radius) var(--radius) 0 0;
}
.edu-dialog .el-dialog__title { color: #fff; font-size: 15px; font-weight: 600; }
.edu-dialog .el-dialog__headerbtn { top: 16px; }
.edu-dialog .el-dialog__headerbtn .el-dialog__close { color: #fff; font-size: 18px; }
.edu-dialog .el-dialog__headerbtn .el-dialog__close:hover { color: #ffe0e9; }
.edu-dialog .el-dialog { border-radius: var(--radius); overflow: hidden; }
.edu-dialog .el-dialog__body { padding: 24px; }
.edu-dialog .el-dialog__footer { border-top: 1px solid var(--border); padding: 14px 24px; }

/* ===== 表格 ===== */
.el-table { border-radius: var(--radius-sm); overflow: hidden; }
.el-table th {
  background: #fafafa !important;
  color: var(--text-primary) !important;
  font-weight: 600;
  font-size: 13px;
  border-bottom: 1px solid #f0f0f0 !important;
}
.el-table--striped .el-table__body tr.el-table__row--striped td { background: #fcfcfd; }
.el-table__body tr:hover > td { background: var(--primary-50) !important; }

/* ===== 卡片 ===== */
.el-card {
  border-radius: var(--radius) !important;
  box-shadow: var(--shadow) !important;
  border: 1px solid var(--border) !important;
  transition: box-shadow 0.2s;
}
.el-card:hover { box-shadow: var(--shadow-md) !important; }

/* ===== 按钮 ===== */
.el-button--primary {
  background: var(--primary) !important;
  border-color: var(--primary) !important;
}
.el-button--primary:hover,
.el-button--primary:focus {
  background: var(--primary-dark) !important;
  border-color: var(--primary-dark) !important;
}
.el-button--primary.is-plain {
  color: var(--primary) !important;
  background: var(--primary-bg) !important;
  border-color: #ffc2d5 !important;
}
.el-button--primary.is-plain:hover {
  background: var(--primary) !important;
  color: #fff !important;
}
.el-button--success { background: var(--success) !important; border-color: var(--success) !important; }
.el-button--warning { background: var(--warning) !important; border-color: var(--warning) !important; }
.el-button--danger { background: var(--danger) !important; border-color: var(--danger) !important; }

/* ===== 分页 ===== */
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background: var(--primary) !important;
  color: #fff !important;
}
.el-pagination.is-background .el-pager li:not(.disabled):hover { color: var(--primary) !important; }

/* ===== 输入框聚焦 ===== */
.el-input.is-active .el-input__inner, .el-input__inner:focus { border-color: var(--primary) !important; }
.el-select .el-input.is-focus .el-input__inner { border-color: var(--primary) !important; }
.el-textarea__inner:focus { border-color: var(--primary) !important; }
.el-range-editor.is-active, .el-range-editor.is-active:hover { border-color: var(--primary) !important; }

/* ===== 单选/复选 ===== */
.el-radio__input.is-checked .el-radio__inner { background: var(--primary) !important; border-color: var(--primary) !important; }
.el-checkbox__input.is-checked .el-checkbox__inner { background: var(--primary) !important; border-color: var(--primary) !important; }
.el-radio__input.is-checked + .el-radio__label { color: var(--primary) !important; }
.el-checkbox__input.is-checked + .el-checkbox__label { color: var(--primary) !important; }

/* ===== Switch ===== */
.el-switch.is-checked .el-switch__core { background: var(--primary) !important; border-color: var(--primary) !important; }

/* ===== Tabs ===== */
.el-tabs__active-bar { background: var(--gradient) !important; height: 3px; border-radius: 2px; }
.el-tabs__item.is-active { color: var(--primary) !important; font-weight: 600; }
.el-tabs__item:hover { color: var(--primary) !important; }

/* ===== Tag ===== */
.el-tag--primary { background: var(--primary-bg) !important; border-color: #ffc2d5 !important; color: var(--primary-dark) !important; }
.el-tag--success { background: #eafaf3 !important; border-color: #b7e9d4 !important; color: #1b7f55 !important; }
.el-tag--warning { background: #fff7ec !important; border-color: #ffd9a8 !important; color: #b8720c !important; }
.el-tag--danger { background: #fff0f2 !important; border-color: #ffc4cc !important; color: #cf3648 !important; }
.el-tag--info { background: #f5f5f7 !important; border-color: #e6e6e6 !important; color: var(--text-secondary) !important; }

/* ===== 消息 ===== */
.el-message--success { background: #eafaf3 !important; border-color: #8fdcbd !important; }
.el-message--warning { background: #fff7ec !important; border-color: #fcd34d !important; }
.el-message--error { background: #fff0f2 !important; border-color: #ffa8b4 !important; }

/* ===== 侧边栏菜单 ===== */
.side-menu .el-menu-item.is-active {
  background: var(--gradient) !important;
  color: #fff !important;
  border-radius: 10px;
  box-shadow: 0 6px 16px rgba(255, 96, 141, 0.28);
}
.side-menu .el-menu-item:hover { background: rgba(255, 96, 141, 0.08) !important; color: var(--primary) !important; }
.side-menu .el-submenu__title:hover { background: rgba(255, 96, 141, 0.08) !important; color: var(--primary) !important; }

/* 二级菜单左缩进 */
.side-menu .el-menu .el-menu-item { padding-left: 20px !important; }
/* 一级菜单文字加粗 */
.side-menu .el-submenu__title { font-size: 14px !important; font-weight: 600 !important; }
/* 隐藏伸缩箭头 */
.side-menu .el-submenu__icon-arrow { display: none !important; }

/* ===== 下拉菜单 ===== */
.el-dropdown-menu__item:hover { background: var(--primary-bg) !important; color: var(--primary) !important; }
.el-dropdown-menu__item:focus { background: var(--primary-bg) !important; color: var(--primary) !important; }

/* ===== 告警 ===== */
.el-alert--info { background: var(--primary-bg) !important; border-color: #ffc2d5 !important; }
.el-alert--warning { background: #fff7ec !important; border-color: #ffd9a8 !important; color: #b8720c !important; }

/* ===== 分割线 ===== */
.el-divider__text { background: #fff; color: var(--text-secondary); font-weight: 500; }

/* 表格操作按钮间距 */
.el-table .cell .el-button { margin: 2px 3px; }

/* ===== 通用页面头部 ===== */
/* 标题不换行、筛选操作区自动换行，避免窄屏下标题被挤成两行 */
.page-header { flex-wrap: wrap !important; gap: 12px 16px; }
.page-title { white-space: nowrap; flex-shrink: 0; }
.header-actions, .filter-right { flex-wrap: wrap; }
</style>
